import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.error.cause.js";
import { useI18n } from "vue-i18n";
import printer from "@/assets/images/svg/printer.svg";
import email from "@/assets/images/svg/email.svg";
import scanner from "@/assets/images/svg/scanner.svg";
import downloadIcon from "@/assets/images/svg/download.svg";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import BookingModule from "@/store/modules/booking";
import { computed, defineComponent, ref } from "vue";
import { Currencies } from "@/constants/currency";
import { ModalStatus } from "@/constants/modal";
import { toggleModalVisible } from "@/utils/vue-helpers/modal";
import CustomersModule from "@/store/modules/customers";
import { BookingStatus } from "@/types/db/product-slot-state";
import { BookingType } from "@/types/db/product-slot-booking";
import UserModule from "@/store/modules/user";
import { cloneDeep, throttle } from "lodash";
import { LogService } from "@/services/logging";
import { BookingStep } from "@/constants/booking";
import { getBookingId, getBookingTeamsSetings, printBookingReceipt, scanTickets, clearCurrentSessionExternalVouchers } from "@/utils/vue-helpers/booking";
import { getBookingTeamsStatus } from "@/utils/helpers/teams";
import { watch } from "vue";
import { BookingTeamsStatus } from "@/interfaces/teams/teams";
import PrinterConfigModule from "@/store/modules/printers-config";
import POSConfigModule from "@/store/modules/pos-config";
import AppModule from "@/store/modules/app";
import FiskalyModule from "@/store/modules/fiskaly";
import { AccountingState, TransactionTypes } from "@/types/db/accounting";
import { roundToNearestMultipleOf5, sumArray } from "@/utils/helpers/common";
import { excludedTaxByPss, restToPay } from "@/utils/vue-helpers/new-accountings";
import { startTransaction } from "@/utils/helpers/fiskaly";
import CashFloatModule from "@/store/modules/cash-float";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import { createOrderSession } from "@/utils/helpers/product-slot-booking";
import AuthModule from "@/store/modules/auth";
import { editOrderExternalVoucherInfoConstruction, hasAppliedAndCompletedExternalVouchers } from "@/api/external-vouchers/incert";
export default defineComponent({
  name: "OrderFinalPage",
  props: {
    compareTwoObjects: {
      required: true,
      type: Function
    },
    buildPatchBookingPayload: {
      required: true,
      type: Function
    }
  },
  setup: function setup() {
    var _BookingModule$select2;

    var iconStyle = "width: 20px; height: 20px;";
    var printerIconContent = printer;
    var printerIconAlt = "printer";
    var emailIconContent = email;
    var emailIconAlt = "email";
    var scannerIconContent = scanner;
    var scannerIconAlt = "Scan";
    var downloadIconContent = downloadIcon;

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var orderReference = computed(function () {
      var _BookingModule$select;

      return BookingModule.selectedBooking ? (_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.reference : "";
    }); // const bookingTotal = BookingModule.pssSumFinaValues;
    // const amountPaid = BookingModule.confirmedAmountsTotal * 100;

    var amountPaid = computed(function () {
      return BookingModule.amountPaid;
    });
    var vats = ref([]);
    var payingCurrency = ((_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.currency) || Currencies.CHF;
    var bookings = computed(function () {
      return Object.values(BookingModule.bookings);
    });
    var roundingTotal = computed(function () {
      return BookingModule.roundingTotal;
    });
    var bookingTotal = computed(function () {
      var _BookingModule$select3, _BookingModule$select4;

      // return BookingModule.pssSumFinaValuesExcludingCancelledTickets;
      var sum = 0;
      var pssList = (_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.pssList;
      var discountAccountings = ((_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.accountings.filter(function (acc) {
        return acc.state === AccountingState.Completed && !acc.refund && acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT;
      })) || [];
      var discountAccountingsEntries = discountAccountings.map(function (acc) {
        return acc.accountingEntriesList;
      }).flat();

      if (pssList) {
        var _loop = function _loop(i) {
          if (pssList[i].bookingStatus === BookingStatus.Canceled || pssList[i].bookingStatus === BookingStatus.Abandoned) {
            // we exclude cancelled/abandoned pss
            return "continue";
          }

          var discountOnPss = 0;

          if (discountAccountingsEntries && discountAccountingsEntries.length) {
            var discountAccE = discountAccountingsEntries.filter(function (ae) {
              return ae.productSlotStateUuid === pssList[i].uuid;
            });

            if (discountAccE && discountAccE.length) {
              discountOnPss = sumArray(discountAccE.map(function (ae) {
                return ae.value;
              }));
            }
          }

          var pssExcludedTax = excludedTaxByPss.value(String(pssList[i].uuid));
          sum = sum + getPSSValue(pssList[i]) + pssExcludedTax - discountOnPss + pssList[i].paymentFeeCollected;
        };

        for (var i = 0; i < pssList.length; i++) {
          var _ret = _loop(i);

          if (_ret === "continue") continue;
        }
      }

      return sum;
    });
    var codesPaymentSum = computed(function () {
      return BookingModule.codesPaymentSum;
    });
    var changeDue = computed(function () {
      if (restToPay.value
      /*BookingModule.leftToPayAmount*/
      > 0) {
        // booking is not fully paid
        return 0;
      }

      var change = amountPaid.value - bookingTotal.value + roundingTotal.value;

      if (payingCurrency === Currencies.CHF) {
        change = roundToNearestMultipleOf5(change);
      }

      return change;
    });
    var requireTeams = ref(false);
    var teamsStatus = ref(BookingTeamsStatus.NotStarted);
    var bookingUuid = computed(function () {
      return BookingModule.selectedBookingUUID;
    });
    var showPrintLabel = computed(function () {
      return PrinterConfigModule.isLabelPrintingEnabled;
    });
    var showScanBtn = computed(function () {
      return !POSConfigModule.getAutoScanTickets;
    });
    var printButtonText = computed(function () {
      return "".concat(PrinterConfigModule.isTicketPrintingEnabled ? t("completeorder.tickets-receipt") : t("completeorder.receipts"), " ").concat(PrinterConfigModule.isLabelPrintingEnabled ? "& " + t("completeorder.labels") : "");
    });
    var selectedBooking = computed(function () {
      return BookingModule.selectedBooking;
    });
    var groupCurrencies = computed(function () {
      return POSConfigModule.groupCurrencies;
    });
    var currencies = computed(function () {
      var _CashFloatModule$cash;

      var currencies = [];
      var startAmounts = (_CashFloatModule$cash = CashFloatModule.cashFloat) === null || _CashFloatModule$cash === void 0 ? void 0 : _CashFloatModule$cash.startAmounts;

      var _loop2 = function _loop2(currency) {
        var currencyInfo = groupCurrencies.value.find(function (c) {
          return c.label === currency;
        });

        if (currencyInfo) {
          currencies.push(currencyInfo);
        }
      };

      for (var currency in startAmounts) {
        _loop2(currency);
      }

      return currencies;
    }); // for multi currency payments

    var selectedCashCurrency = computed(function () {
      if (selectedBooking.value && selectedBooking.value.uuid) {
        return BookingModule.selectedCashCurrency;
      }

      return null;
    });
    var groupCurrency = computed(function () {
      return currencies.value[0];
    });
    watch(bookingUuid, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var teamsSettings, bookingId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getBookingTeamsSetings();

            case 2:
              teamsSettings = _context.sent;

              if (!(!teamsSettings || !teamsSettings.length)) {
                _context.next = 6;
                break;
              }

              // booking doesn't require teams
              requireTeams.value = false;
              return _context.abrupt("return");

            case 6:
              requireTeams.value = true;
              _context.next = 9;
              return getBookingId();

            case 9:
              bookingId = _context.sent;

              if (!bookingId) {
                _context.next = 15;
                break;
              }

              console.log("--------- calling getBookingTeamsStatus from setup/watch of completeOrder");
              _context.next = 14;
              return getBookingTeamsStatus(bookingId, teamsSettings);

            case 14:
              teamsStatus.value = _context.sent;

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), {
      deep: true
    });
    return {
      t: t,
      bookingTotal: bookingTotal,
      amountPaid: amountPaid,
      changeDue: changeDue,
      bookings: bookings,
      vats: vats,
      payingCurrency: payingCurrency,
      printerIconContent: printerIconContent,
      printerIconAlt: printerIconAlt,
      iconStyle: iconStyle,
      emailIconContent: emailIconContent,
      emailIconAlt: emailIconAlt,
      scannerIconContent: scannerIconContent,
      scannerIconAlt: scannerIconAlt,
      codesPaymentSum: codesPaymentSum,
      orderReference: orderReference,
      downloadIconContent: downloadIconContent,
      requireTeams: requireTeams,
      teamsStatus: teamsStatus,
      BookingTeamsStatus: BookingTeamsStatus,
      showPrintLabel: showPrintLabel,
      showScanBtn: showScanBtn,
      printButtonText: printButtonText,
      selectedCashCurrency: selectedCashCurrency,
      groupCurrency: groupCurrency,
      BookingType: BookingType,
      selectedBooking: selectedBooking
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var booking, teamsSettings, bookingId;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              booking = BookingModule.selectedBooking;

              if (!(!booking || !booking.uuid)) {
                _context2.next = 3;
                break;
              }

              throw new Error(PSBErrors.NoBookingInModule);

            case 3:
              // this.vats = await getVats(booking);
              console.log("-------- calling getBookingTeamsSetings from CompletedOrder created");
              _context2.next = 6;
              return getBookingTeamsSetings();

            case 6:
              teamsSettings = _context2.sent;
              console.log("------ teamsSettings");
              console.log(teamsSettings);

              if (!(!teamsSettings || !teamsSettings.length)) {
                _context2.next = 14;
                break;
              }

              // booking doesn't require teams
              console.log("------ so there is no teams settings");
              _this.requireTeams = false;
              _context2.next = 24;
              break;

            case 14:
              console.log("------ so there is teams settings");
              _this.requireTeams = true;
              _context2.next = 18;
              return getBookingId();

            case 18:
              bookingId = _context2.sent;

              if (!bookingId) {
                _context2.next = 24;
                break;
              }

              console.log("--------- calling getBookingTeamsStatus from created of completeOrder");
              _context2.next = 23;
              return getBookingTeamsStatus(bookingId, teamsSettings);

            case 23:
              _this.teamsStatus = _context2.sent;

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              AppModule.updatedIsLoading(false);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  methods: {
    endBooking: function endBooking() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var completedBooking, nextBookingUUID;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                completedBooking = BookingModule.selectedBooking;

                if (completedBooking) {
                  _context4.next = 3;
                  break;
                }

                throw new Error(PSBErrors.NoBookingInModule);

              case 3:
                // Create new booking if we have only one booking
                if (_this2.bookings.length === 1) {
                  BookingModule.createNewBooking();
                } // remove previous booking


                BookingModule.removeBooking(completedBooking);
                _context4.next = 7;
                return CustomersModule.setSelectedCustomers([]);

              case 7:
                // We need to remove the booking receipt signature from Fiskaly state
                FiskalyModule.removeSignatureQrCodes(completedBooking.uuid);
                FiskalyModule.removeTransaction(completedBooking.uuid);
                nextBookingUUID = _this2.bookings[_this2.bookings.length - 1].uuid;

                _this2.selectBooking(nextBookingUUID);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    selectBooking: function selectBooking(uuid) {
      if (!uuid) {
        throw new Error(PSBErrors.HasNoUUID);
      }

      BookingModule.selectBooking(uuid);
    },
    sendEmail: function sendEmail() {
      toggleModalVisible(ModalStatus.SendEmail);
    },
    openPrintTicketsAndReceiptModal: function openPrintTicketsAndReceiptModal() {
      if (!PrinterConfigModule.isLabelPrintingEnabled && !PrinterConfigModule.isTicketPrintingEnabled) {
        printBookingReceipt();
      } else {
        toggleModalVisible(ModalStatus.PrintTicketsAndReceipt);
      }
    },
    throttleScanning: throttle(scanTickets, 500),
    editOrder: function editOrder() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _event;

        var originalCopy, bookingUUID, orderSession;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                (_event = event) === null || _event === void 0 ? void 0 : _event.stopPropagation();
                originalCopy = cloneDeep(BookingModule.selectedBooking);

                if (originalCopy) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                bookingUUID = String(originalCopy.uuid);
                LogService.info("User clicked to edit a booking that he has just completed uuid ".concat(bookingUUID)); // order session ended, clear booking changes

                BookingModule.clearBookingChanges(BookingModule.selectedBookingUUID); // remove the applied promocode from the state

                BookingModule.removePromocodes(bookingUUID); //////////// EXTERNAL VOUCHERS LOGIC
                // Now lets check if this booking has external vouchers and remove them from the module

                console.log("Now lets check if this booking has external vouchers and remove them from the module");
                clearCurrentSessionExternalVouchers(String(BookingModule.currentOrderSessionId)); ////////////
                // Make it Order step

                BookingModule.setBookingStep({
                  bookingUUID: bookingUUID,
                  step: BookingStep.Order
                }); // Create a new session to edit the order

                orderSession = createOrderSession({
                  bookingUuid: bookingUUID,
                  currency: originalCopy.currency,
                  sellerId: UserModule.userId,
                  sellerCogn: AuthModule.cognitoId
                });
                BookingModule.addOrderSessionToBooking({
                  orderSession: orderSession,
                  bookingUuid: bookingUUID
                }); //////////// EXTERNAL VOUCHERS LOGIC
                // If this booking has applied and confirmed external voucher then we need an async call by the library to check all info of those already applied vouchers so that we build a helper object in the state to auto apply them later in this new order session

                if (!hasAppliedAndCompletedExternalVouchers(originalCopy)) {
                  _context5.next = 16;
                  break;
                }

                _context5.next = 16;
                return editOrderExternalVoucherInfoConstruction(originalCopy);

              case 16:
                //////////// EXTERNAL VOUCHERS LOGIC
                // Edit order is considered as a new transaction, so we need to remove the previous transaction and create a new one
                FiskalyModule.removeTransaction(bookingUUID);
                _context5.next = 19;
                return startTransaction(bookingUUID);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    showDownloadTicketsModal: function showDownloadTicketsModal() {
      toggleModalVisible(ModalStatus.DownloadTickets);
    },
    showTeamsView: function showTeamsView() {
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Teams
      });
    }
  }
});